angular.module('trainerWebApp.services').factory('notificationService', [function() {
  var notifications = [];
  return {
    getNotification: function() {
      return notifications;
    },

    setNotification: function (value) {
      if(value && notifications && notifications.length > 0){
        if(_.findWhere(notifications, value)){
          return;
        }
        else if(notifications[0].pageToShow != value.pageToShow)
          notifications = [];
      }
      notifications.push(value);
    },

    removeNotification: function (value) {
      notifications = _.without(notifications, _.findWhere(notifications, value));
    },

    clearNotification: function(){
      notifications = [];
    }
  };
}]);
